import {
  useQParam,
  Contact,
  Button,
  PlusIcon,
  SearchBar,
  SearchIcon,
} from '@trufla-technology/trumarket-react-design-system';
import {
  useAssignUsersToLocations,
  useListLocations,
} from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { getTitleCase } from 'app/utils';
import { useState } from 'react';
import { NewLocationLoading } from './NewLocationLoading';
import './style.scss';

type Props = {
  refetchLocations?: () => void;
  locationsKeysString?: string;
};

export const NewLocation = ({
  refetchLocations,
  locationsKeysString,
}: Props) => {
  const userKey = useQParam('userKey');
  const assignUsersToLocations = useAssignUsersToLocations();
  const [searchValue, setSearchValue] = useState<string>();

  const { data, handleFilter, removeFilters } = useListLocations({
    paginate: {
      limit: 50,
      offset: 0,
    },
  });

  const locations = locationsKeysString
    ? data?.filter(
        (location) => !locationsKeysString.split(',')?.includes(location.key!),
      )
    : data;

  const handleAssignUserToLocations = async (locationKey: string) => {
    await assignUsersToLocations({
      assigning: [
        {
          locationKey,
          userKey: userKey!,
        },
      ],
    });
    refetchLocations?.();
  };

  const handleSearch = (value: string) => {
    setSearchValue(value);
    if (!value?.trim().length) return removeFilters(['name']);
    handleFilter({
      name: value,
    });
  };

  if (!locations) return <NewLocationLoading />;

  return (
    <div className="add-location-container">
      <SearchBar
        placeholder="Search"
        onSearch={handleSearch}
        icon={<SearchIcon fill="#54616C" />}
        value={searchValue || ''}
      />
      {locations?.map(
        /* @ts-ignore - still not returning on the types in openApi */
        ({ key, name, usersCount }) => (
          <Contact
            key={key}
            name={getTitleCase(name!)}
            email={`${usersCount} Member`}
            button={
              <Button onClick={() => handleAssignUserToLocations(key!)}>
                <PlusIcon size="extra-medium" fill="var(--tru-white)" />
              </Button>
            }
          />
        ),
      )}
    </div>
  );
};
